import { useState, useEffect, createContext, useContext } from "react";

const VisibilityOverrideContext = createContext({
  includeExcluded: false,
  setIncludeExcluded: () => {},
});

export function VisibilityOverrideProvider({ children }) {
  const [includeExcluded, setIncludeExcluded] = useState(() => {
    try {
      return sessionStorage.getItem("include_excluded") === "true";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem("include_excluded", String(includeExcluded));
    } catch {}
  }, [includeExcluded]);

  return (
    <VisibilityOverrideContext.Provider value={{ includeExcluded, setIncludeExcluded }}>
      {children}
    </VisibilityOverrideContext.Provider>
  );
}

export function useVisibilityOverride() {
  return useContext(VisibilityOverrideContext);
}
